/*
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projectSettings';

export default defineMessages({
  projectSettingsAssets: {
    id: `${scope}.projectSettingsAssets`,
    defaultMessage: 'Assets',
  },
  projectSettingsDescription: {
    id: `${scope}.projectSettingsDescription`,
    defaultMessage: 'Choose an asset source to add to your project.',
  },
});
